module.exports = __webpack_public_path__ + "img/ic_32_profile_delete.bc1a9838.svg";